import * as React from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SvgCheckcircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 44,
  height: 44,
  viewBox: "14 14 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M22 30a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z",
  fill: "#000",
  style: {
    fill: "currentColor"
  }
}), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m20.813 23.61-1.974-1.976-.672.667 2.646 2.646 5.681-5.681-.667-.667-5.014 5.011Z",
  fill: "#fff"
})));

export { SvgCheckcircle as default };
